import type { IObjectViewModel } from '../../../interfaces';
import { SceneItemKind } from '../../../interfaces';
import type { IIndicationStrategy } from '../Indications.controller';
import type { IIndicationToolFactory } from '../Indications.factory';
import type { IndicationsService } from '../Indications.service';
import type { IValue } from '@/engine/DataFlow/Graph';
import type { IIndicationsViewModelFactory } from '../interfaces';
import { SplineIndicationStrategy } from './SplineIndicationStrategy';
import { SplineIndicationModel } from '../area/SplineIndication.model';
import type { PlanningAlgorithm } from '@/engine/PlanningAlgorithm/PlanningAlgorithm';
import type { ICommandProcessor } from '../../core/interfaces/Command';
import { SplineIndicationAdder } from './SplineAdder';
import type { IRemover } from '@/engine/UIPresentation/Interfaces';

export class SplineToolFactory implements IIndicationToolFactory {
  private _indicationsService: IndicationsService;

  public constructor(indicationsService: IndicationsService) {
    this._indicationsService = indicationsService;
  }

  public createIndicationStrategy(
    planningAlgorithm: PlanningAlgorithm,
    commandProcessor: ICommandProcessor,
    remover: IRemover
  ): IIndicationStrategy {
    return new SplineIndicationStrategy(
      this._indicationsService,
      planningAlgorithm,
      commandProcessor,
      new SplineIndicationAdder(planningAlgorithm, this._indicationsService),
      remover
    );
  }

  public createIndicationModel(): IValue {
    return new SplineIndicationModel({ basePts: [] });
  }

  public createIndicationViewModel(
    vmFactory: IIndicationsViewModelFactory,
    phaseId: string | undefined
  ): IObjectViewModel {
    return vmFactory.createViewModel(SceneItemKind.AreaIndication, phaseId);
  }
}
